import { useCallback, useState } from "react";

export interface PaginationCursor {
  readonly cursor: string | null;
  readonly canGoPrev: boolean;
  readonly goPrev: () => void;
  readonly goNext: (next: string | null) => void;
}

// Stack-based pagination over opaque cursors. The first page is keyed by
// `null`; subsequent pages push the server-supplied next-cursor onto the
// stack. goPrev pops back; goNext is a no-op if no next cursor was given.
export function usePaginationCursor(): PaginationCursor {
  const [stack, setStack] = useState<readonly (string | null)[]>([null]);
  const cursor = stack[stack.length - 1] ?? null;
  const canGoPrev = stack.length > 1;

  const goPrev = useCallback(() => {
    setStack((prev) => (prev.length > 1 ? prev.slice(0, -1) : prev));
  }, []);

  const goNext = useCallback((next: string | null) => {
    if (next !== null) setStack((prev) => [...prev, next]);
  }, []);

  return { cursor, canGoPrev, goPrev, goNext };
}
